import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Guardian } from "../../Models/guardian.models";

export interface ParentsInfo {
  name: string;
  occupation?: string;
  mobile: string;
  telno?: string;
}
export interface SelectedParents {
  id: number;
  name: string;
  parentalRelationship: string;
  mobile: string;
  address: string;
}
const initialState = {
  firstName: "",
  middleName: "",
  lastName: "",
  gender: "",
  address: "",
  fatherInfo: {
    name: "",
    occupation: "",
    telno: "",
    mobile: "",
  } as ParentsInfo | null,
  motherInfo: {
    name: "",
    occupation: "",
    telno: "",
    mobile: "",
  } as ParentsInfo | null,
  guardianInfo: [
    {
      name: "",
      relation: "",
      address: "",
      mobile: "",
    },
  ] as Guardian[],
  dateOfBirth: "",
  registeredAt: "",
  selectedParents: null as SelectedParents | null,
  nationality: "",
  religion: "",
  schoolBranchId: null as number | null,
  classId: null as number | null,
  transportId: null as number | null,
  lunchPackagedId: null as number | null,
  schoolFees: {
    admissionFee: null as number | null,
    annualFee: null as number | null,
    extraClassFee: null as number | null,
    monthlyFee: null as number | null,
    stationeryFee: null as number | null,
    transportationFee: null as number | null,
    examFee: null as number | null,
    extraCirculumFee: null as number | null,
    lunchFee: null as number | null,
  },
};

export const studentAdmissionSlice = createSlice({
  name: "studentAdmission",
  initialState,
  reducers: {
    setFirstName: (state, action: PayloadAction<string>) => {
      state.firstName = action.payload;
    },
    setMiddleName: (state, action: PayloadAction<string>) => {
      state.middleName = action.payload;
    },
    setLastName: (state, action: PayloadAction<string>) => {
      state.lastName = action.payload;
    },
    setAddress: (state, action: PayloadAction<string>) => {
      state.address = action.payload;
    },
    setDOB: (state, action: PayloadAction<string>) => {
      state.dateOfBirth = action.payload;
    },
    setGender: (state, action: PayloadAction<string>) => {
      state.gender = action.payload;
    },
    setGuardian: (state, action: PayloadAction<Array<Guardian> | []>) => {
      state.guardianInfo = action.payload;
    },
    setFatherInfo: (state, action: PayloadAction<ParentsInfo>) => {
      state.fatherInfo = action.payload;
    },
    setMotherInfo: (state, action: PayloadAction<ParentsInfo>) => {
      state.motherInfo = action.payload;
    },
    setSelectedParents: (state, action: PayloadAction<any>) => {
      state.selectedParents = action.payload;
    },
    setNationality: (state, action: PayloadAction<string>) => {
      state.nationality = action.payload;
    },
    setReligion: (state, action: PayloadAction<string>) => {
      state.religion = action.payload;
    },
    setSchoolBranchId: (state, action: PayloadAction<number | null>) => {
      state.schoolBranchId = action.payload;
    },
    setClassId: (state, action: PayloadAction<number | null>) => {
      state.classId = action.payload;
    },
    setTransportId: (state, action: PayloadAction<number | null>) => {
      state.transportId = action.payload;
    },
    setLunchPackagesId: (state, action: PayloadAction<number | null>) => {
      state.lunchPackagedId = action.payload;
    },
    setAdmissionFee: (state, action: PayloadAction<number | null>) => {
      state.schoolFees.admissionFee = action.payload;
    },
    setAnnualFee: (state, action: PayloadAction<number | null>) => {
      state.schoolFees.annualFee = action.payload;
    },
    setExtraClassFee: (state, action: PayloadAction<number | null>) => {
      state.schoolFees.extraClassFee = action.payload;
    },
    setMontlyFee: (state, action: PayloadAction<number | null>) => {
      state.schoolFees.monthlyFee = action.payload;
    },
    setStationeryFee: (state, action: PayloadAction<number | null>) => {
      state.schoolFees.stationeryFee = action.payload;
    },
    setTransportationFee: (state, action: PayloadAction<number | null>) => {
      state.schoolFees.transportationFee = action.payload;
    },
    setExamFee: (state, action: PayloadAction<number | null>) => {
      state.schoolFees.examFee = action.payload;
    },
    setExtraCirculumFee: (state, action: PayloadAction<number | null>) => {
      state.schoolFees.extraCirculumFee = action.payload;
    },
    setLunchFee: (state, action: PayloadAction<number | null>) => {
      state.schoolFees.lunchFee = action.payload;
    },
    setRegisteredAt: (state, action: PayloadAction<string>) => {
      state.registeredAt = action.payload;
    },

    reset: (state) => {
      state = initialState;
      return state;
    },
  },
});
export const {
  setFirstName,
  setLastName,
  setMiddleName,
  setAddress,
  setDOB,
  setGender,
  setGuardian,
  setSelectedParents,
  setFatherInfo,
  setMotherInfo,
  setNationality,
  setReligion,
  setSchoolBranchId,
  setClassId,
  setTransportId,
  setLunchPackagesId,
  setAdmissionFee,
  setAnnualFee,
  setExtraClassFee,
  setMontlyFee,
  setStationeryFee,
  setTransportationFee,
  setExamFee,
  setExtraCirculumFee,
  setLunchFee,
  setRegisteredAt,
  reset,
} = studentAdmissionSlice.actions;
export const studentAdmissionReducer = studentAdmissionSlice.reducer;
